import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'safeUrl',
})
export class SafeUrlPipe implements PipeTransform {
  constructor(private _d: DomSanitizer) {}

  transform(oldURL: string): SafeUrl {
    return this._d.bypassSecurityTrustResourceUrl(oldURL);
  }
}
